import { render } from "./SavedClaimHMOComponent.vue?vue&type=template&id=f8364d28&scoped=true"
import script from "./SavedClaimHMOComponent.vue?vue&type=script&lang=js"
export * from "./SavedClaimHMOComponent.vue?vue&type=script&lang=js"

import "./SavedClaimHMOComponent.vue?vue&type=style&index=0&id=f8364d28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8364d28"]])

export default __exports__